export default "__VITE_ASSET__Cb20qMpy__"